import React from 'react';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import './FAQ.scss';
import WalletIcon from '../UI/SVG/WalletIcon';
import ArrowIcon from '../UI/SVG/ArrowIconProps.';
import { sendEvent } from '../../utils';
import { FaqEntity } from '../../types/content';

interface IFAQProps {
  context?: IContent;
}

const FAQ = ({ context }: IFAQProps) => {

  const redirectAndSendEvent = (e: React.MouseEvent<HTMLLIElement, MouseEvent>, item: FaqEntity) => {
    e.preventDefault();
    e.stopPropagation();

    sendEvent(item.tracking + item.question);
    window.location.href = item.link;
  };

  return (
    <section className='wallet-faq'>
      <div className='wallet-faq__top-icon'>
        <WalletIcon fill='white' />
      </div>
      <div className='wallet-container wallet-faq__inner'>
        <h2 dangerouslySetInnerHTML={{ __html: context.about.title }} />
        <p>{context.about.subtitle}</p>
        <ul className='wallet-faq__questions'>
          {context.about.faq.map((item, index) => (
            <li key={`faq_${index}`} className='wallet-faq__questions__item'
                onClick={event => redirectAndSendEvent(event, item)}>
              <a>
                {item.question}
                <ArrowIcon direction='right' fill='#35c1cf' />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default withContent(FAQ);
